import React from 'react';
import styles from './Dashboard.module.scss';

import OffRampBox from '../../components/DashboardLayout/OtherOptions/OffRampBox';
import config from '../../config/config';
import {
  openModal as openModalAction,
  QCD_HISTORY_MODAL,
} from '../../redux/modules/modals/modals.module';
import { getAllQCDHistory } from '../../redux/modules/qcdHistory/QCDHistory.selector';
import { useDispatch, useSelector } from 'react-redux';

const CTATiles = ({ preRMD, qcdSumaries = [] }) => {
  const qcdHistory = useSelector(getAllQCDHistory);
  const dispatch = useDispatch();
  return (
    <div className={styles['container']}>
      {/* pre rmd tiles */}
      {preRMD && (
        <div className={styles['offRamps']}>
          <div className={styles['cta-tiles']}>
            <OffRampBox
              title="Update Your Beneficiaries"
              description="Because your beneficiaries may affect your RMD calculation, it’s
                        critical that the information we have on file is accurate."
              btnTxt="Update Beneficiaries"
              btnAction={`${config.url}/usis/my-accounts/profile/beneficiaries`}
              newTab={true}
            />
            <OffRampBox
              title="Link Your Bank Accounts"
              description="Securely link your checking or savings account to your T. Rowe
                        Price account for quick and easy distributions."
              btnTxt="Link My Accounts"
              btnAction={`${config.url}/usis/my-accounts/profile/linked-bank-accounts`}
              newTab={true}
            />
          </div>
          <div className={styles['spacer']} />
          <div className={styles['cta-tiles']}>
            <OffRampBox
              title="Open a New General Investing Account"
              description="If you don’t need your RMD for living expenses, you can
                        re-invest some or all of your distribution in a general
                        investing account."
              btnTxt="Explore Investments Options"
              btnAction={`${config.url}/personal-investing/accounts/general-investing/index.html`}
              newTab={true}
            />
            <OffRampBox
              title="Explore Qualified Charitable Distributions (QCDs)"
              description="Donate to a qualified charity with a distribution from your IRA, or view your previous requests for QCDs."
              btnTxt="Make a QCD"
              btnAction={`${config.url}/usis/transactions/qcd/landing`}
              newTab={false}
              actionLinkText={
                qcdSumaries.length > 0 ? 'Review QCD Summaries' : undefined
              }
              actionLink={() => {
                dispatch(openModalAction(QCD_HISTORY_MODAL, {}));
              }}
            />
          </div>
        </div>
      )}
      {/* rmd tiles */}
      {!preRMD && (
        <div className={styles['offRamps']}>
          <div className={styles['cta-tiles']}>
            <OffRampBox
              title="Reinvest in a General Investing Account"
              description="Put your RMD back to work in an existing or new general Investing account, such as a mutual fund, ETF, or brokerage account."
              btnTxt="Explore Investment Options"
              btnAction={`https://www.troweprice.com/personal-investing/accounts/general-investing/index.html`}
              newTab={true}
            />
            <OffRampBox
              title="Contribute to a 529 College Savings Plan"
              description="Help a loved one pay for college expenses, K-12 education, and even student loan repayments."
              btnTxt="Browse College Savings Plans"
              btnAction={`https://www.troweprice.com/personal-investing/products-and-services/college-savings-plans.html`}
              newTab={true}
            />
          </div>
          <div className={styles['spacer']} />
          <div className={styles['cta-tiles']}>
            <OffRampBox
              title="Make a Qualified Charitable Distribution (QCD)"
              description="Use your RMD to make a nontaxable donation to a qualifying charity."
              btnTxt="Make a QCD"
              btnAction={`${config.url}/usis/transactions/qcd/landing`}
              newTab={false}
              actionLinkText={
                qcdHistory.length > 0 ? 'Review QCD Summaries' : undefined
              }
              actionLink={() => {
                dispatch(openModalAction(QCD_HISTORY_MODAL, {}));
              }}
            />
            <OffRampBox
              title="One-Time Distribution"
              description="Make a distribution to your bank account or by check from your eligible IRAs that will count toward your RMD amount."
              btnTxt="Take a One-Time Distribution"
              btnAction={`${config.url}/usis/transactions/sell`}
              newTab={false}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CTATiles;
